import goldMemberBanner from '@assets/common/gold_member_banner.webp';
import diamondMemberBanner from '@assets/common/diamond_member_banner.webp';
import blackMemberBanner from '@assets/common/black_member_banner.webp';

export const popupBanner = {
  Gold: goldMemberBanner,
  Diamond: diamondMemberBanner,
  Black: blackMemberBanner
};
export const messages = {
  Gold: [
    'おめでとうございます。',
    'ゴールドメンバーに昇格しました！\n ',
    'より希望に沿った男性とマッチングされやすくなります。'
  ],
  Diamond: [
    'おめでとうございます。',
    '上位20％のダイヤモンドメンバーに昇格しました！\n ',
    'より洗練された男性が貴方を待っています。'
  ],
  Black: [
    'おめでとうございます。',
    '上位3%のブラックメンバーに昇格しました！\n ',
    '最高級のデートをお楽しみください。'
  ]
};
